export default "__VITE_ASSET__ChcrU8p2__"